export const getProcessStatement = (state, id) => state.processStatement.processStatements.entries[id];
